import React from 'react';
import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react';
import { FiLock } from 'react-icons/fi';
import ModalShell from '../../../components/ui/ModalShell';
import { ff } from '../../../theme';
import WalletWithdrawalSuccessIllustration from './WalletWithdrawalSuccessIllustration';

export interface WalletWithdrawalSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onViewStatus: () => void;
}

const WalletWithdrawalSuccessModal: React.FC<WalletWithdrawalSuccessModalProps> = ({
  isOpen,
  onClose,
  onViewStatus,
}) => (
  <ModalShell
    isOpen={isOpen}
    onClose={onClose}
    size="sm"
    footer={
      <Box mt={5}>
        <Button variant="ink" w="100%" onClick={onViewStatus}>
          View status
        </Button>
        <Box h="1px" bg={ff.line} my={5} />
        <Flex align="center" justify="center" gap={2}>
          <Icon as={FiLock} boxSize={3.5} color={ff.muted} flexShrink={0} />
          <Text fontSize="12px" color={ff.text2} lineHeight="1.4">
            FoodFluence takes a 5% processing fee on all withdrawals.
          </Text>
        </Flex>
      </Box>
    }
  >
    <Box textAlign="center">
      <WalletWithdrawalSuccessIllustration />
      <Text as="h2" textStyle="display" fontSize="28px" color={ff.ink} mb={2}>
        Your withdrawal is complete
      </Text>
      <Text fontSize="15px" color={ff.text2} lineHeight="1.5">
        You can monitor the status of your withdrawal in the wallet tab.
      </Text>
    </Box>
  </ModalShell>
);

export default WalletWithdrawalSuccessModal;
